import type { Course } from '../types/course';

const STORAGE_KEY = 'temp_courses';

export const localStore = {
  saveTempCourse: (course: Partial<Course>) => {
    try {
      const tempCourses = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      tempCourses.push({ ...course, tempId: Date.now() });
      localStorage.setItem(STORAGE_KEY, JSON.stringify(tempCourses));
      return true;
    } catch (error) {
      console.error('Erreur de sauvegarde temporaire:', error);
      return false;
    }
  },

  getTempCourses: () => {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    } catch {
      return [];
    }
  },

  clearTempCourses: () => {
    localStorage.removeItem(STORAGE_KEY);
  }
};